import axios from 'axios'
import { Toast } from 'vant'
const IS_PROD = ["production", "prod"].includes(process.env.NODE_ENV)
// 创建 axios 实例
const request = axios.create({
  // API 请求的默认前缀
  baseURL: process.env.VUE_APP_API_BASE_URL,
  // baseURL: 'http://icare.wechat.mrye.xin',
  // baseURL: '',
  timeout: 60000, // 请求超时时间
  // headers: {
  //   'Content-Type': 'application/json;charset=UTF-8',
		// // 'Content-Type':'multipart/form-data'
  // }
})

// 异常拦截处理器
const errorHandler = (error) => {
  if (error.response) {
    // const data = error.response.data
    if (error.response.status === 403) {
      Toast('403')
    }
  }
  return Promise.reject(error)
}

// request interceptor
request.interceptors.request.use(config => {
  // console.log(config)
  const TOKEN = localStorage.getItem('TOKEN')
  if (TOKEN) {
    config.headers['token'] = TOKEN
  }
  return config
}, errorHandler)

// response interceptor
request.interceptors.response.use((response) => {
  const data = response.data
  if ([6001, 7001, 7003, 1003].includes(data.code)) {
    Toast(data.msg)
    return
  }
  if (!IS_PROD) { // 测试环境用
    return data
  }
  if (data.code === 6002 || data.code === 6001) { // 展示后端的错误提示
    localStorage.removeItem('TOKEN')
    window.location.reload()
  }
  return data
}, errorHandler)

export default request
